import { useEffect, useRef } from 'react';
import { useAppToast } from '../contexts/AppToastContext.jsx';

/**
 * Show a fixed toast when `error` is set — for long forms where a top banner
 * may be off-screen after the user scrolls to submit.
 */
export function useErrorToast(error) {
  const { showError } = useAppToast();
  const lastShown = useRef('');

  useEffect(() => {
    const message = typeof error === 'string' ? error.trim() : '';
    if (message && message !== lastShown.current) {
      showError(message);
      lastShown.current = message;
    }
    if (!message) {
      lastShown.current = '';
    }
  }, [error, showError]);
}

/**
 * Show a fixed toast when `success` is set.
 */
export function useSuccessToast(success) {
  const { showSuccess } = useAppToast();
  const lastShown = useRef('');

  useEffect(() => {
    const message = typeof success === 'string' ? success.trim() : '';
    if (message && message !== lastShown.current) {
      showSuccess(message);
      lastShown.current = message;
    }
    if (!message) {
      lastShown.current = '';
    }
  }, [success, showSuccess]);
}
